export const config = {
	apiUrl: process.env.REACT_APP_URL_API ?? '',// ?? "https://localhost:7078",
	realtimeUrl: process.env.REACT_APP_URL_REALTIME ?? '',// ?? "https://localhost:7078/realtime"
};